// Mapper: domain monitoring filter params (number[] arrays + flags) → transport
// LC_MonitoringFiltersIn (CSV strings). Same toCSV/numbersToCSV pattern used by
// employeeFiltered.service.ts. Empty/omitted arrays map to null ("Todos").

import type {
  GetMonitoringFiltersParams,
  LC_MonitoringFiltersIn,
} from '../types/monitoringFilters.types';


function numbersToCSV(ids?: number[]): string | null {
  return ids && ids.length > 0 ? ids.join(',') : null;
}

export function mapMonitoringFiltersToRequest(
  params: GetMonitoringFiltersParams,
): LC_MonitoringFiltersIn {
  return {
    companyIds: numbersToCSV(params.companyIds),
    areaIds: numbersToCSV(params.areaIds),
    costCenterIds: numbersToCSV(params.costCenterIds),
    locationIds: numbersToCSV(params.locationIds),
    groupIds: numbersToCSV(params.groupIds),
    contractModalityIds: numbersToCSV(params.contractModalityIds),
    includeWithoutSchedule: params.includeWithoutSchedule ?? false,
    scheduleRestriction: params.scheduleRestriction ?? false,
  };
}
